import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import _ from "lodash";
import moment from "moment";
import { Helmet } from "react-helmet";
import { Pagination, Skeleton } from "@mui/material";
import { toast } from "react-toastify";

import notAvailableImg from "../../assets/not_available.png";
import Footer from "../../components/footer/Footer.jsx";
import { filterItems } from "../../components/global/filter/initialStates.js";
import CheckInCheckOutCalender from "../../components/global/checkin-checkout-calander/index.jsx";
import Button from "../../components/global/button/index.jsx";
import GuestInput from "../../components/guest-input/Guestinput.jsx";
import PropertiesSort from "../../components/property-listing-cards/properties-sort.jsx";
import FiltersDesktop from "../../components/global/filter/FiltersDesktop.jsx";
import PropertyFilterModal from "../../components/property-listing-cards/property-filter-modal.jsx";
import ListingSortModal from "../../components/property-listing-cards/listing-sort-modal.jsx";
import SelectSuggestionType from "../../components/property-listing-cards/SelectSuggestionType.jsx";
import SkeletonCardsWrapper from "../../components/property-listing-cards/sketon-card/index.jsx";
import NotAvailablePropertyCard from "../../components/property-listing-cards/not-available-property-card.jsx";
import PropertyCard from "../../components/property-card/property-card.jsx";
import LocationSearch from "../../components/Locationsearch/index.jsx";
import { availablePropertiesApi, suggestedPropertiesApi } from "../../api/propertyListingApi.js";
import { generateListingUrl, processListingParams } from "../../utils/formatting";
import { getLikedPropertiesApi } from "../../api/propertyApi";
import GlobalImage from "../../components/global/image/image";

import "./styles.css";
import GoogleMap from "../../components/property-listing-cards/google-map";
import SuggestedPropertyCard from "../../components/suggestedPropertyCard";
/** Main Page Function*/

export const initialExtraDetailsState = {
  summary: {
    isLessRoomSuggestionExists: false,
    isGreaterRoomSuggestionExists: false,
    maxPrice: 0,
    totalProperties: 0,
    minPrice: 0,
  },
  pagination: {
    itemsPerPage: 20,
    currentPage: 0,
    totalPages: 0,
    totalCount: 0,
  },
};

export const initialSearchState = {
  propertyDetails: {
    propertyId: null,
    propertyName: null,
  },

  location: {
    country: null,
    city: null,
    province: null,
    district: null,
    latitude: null,
    longitude: null,
    label: null,
  },

  bookingDates: {
    checkinDate: moment().format("YYYY-MM-DD"),
    checkoutDate: moment().add(1, "day").format("YYYY-MM-DD"),
  },

  guests: {
    adultCount: 2,
    childCount: 0,
    childAges: [],
    roomCount: 1,
  },
};

function PropertyListing() {
  const isLogged = localStorage.getItem("logged");

  const [searchCriteria, setSearchCriteria] = useState(initialSearchState);
  const [errors, setErrors] = useState({
    location: null,
    guests: null,
    bookingDates: null,
  });

  const [availableProperties, setAvailableProperties] = useState([]);
  const [suggestedProperties, setSuggestedProperties] = useState([]);
  const [extraDetails, setExtraDetails] = useState(initialExtraDetailsState);

  const navigate = useNavigate();
  const location = useLocation();

  const [isTouched, setIsTouched] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const summary = extraDetails?.summary;
  const pagination = extraDetails?.pagination;

  const params = processListingParams(location.search);

  const isSearchChanged = isSearchValuesChanged(params, searchCriteria);

  const queryFilters = params.filters || {};

  const paramFilters = {
    price: [queryFilters.minPrice, queryFilters.maxPrice],
    star: [queryFilters.minStarRating, queryFilters.maxStarRating],
    score: [queryFilters.minReviewScore, queryFilters.maxReviewScore],
    policy: queryFilters.cancelationPolicyTypes || [],
    propertyTypeIds: queryFilters.propertyTypeIds || [],
    meals: queryFilters.meals || [],
  };

  async function fetchProperties() {
    setIsLoading(true);

    const criteriaKeys = Object.keys(searchCriteria);
    const filteredParams = _.pick(params, criteriaKeys);

    setSearchCriteria(filteredParams);

    const payload = {
      ...params.propertyDetails,
      ...params.location,
      ...params.bookingDates,
      ...params.guests,
      ...params.filters,
      ...params.pagination,

      sortBy: params.sortOptions.by,
      sortOrder: params.sortOptions.order,

      searchRoomCountType: params.searchOptions.roomCountType,
    };

    availablePropertiesApi(payload)
      .then((res) => {
        setAvailableProperties(res.data.availableProperties);
        setExtraDetails({
          summary: res.data.summary,
          pagination: res.data.pagination,
        });
      })
      .catch((error) => {
        toast.error(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    suggestedPropertiesApi()
      .then((res) => {
        setSuggestedProperties(res.data.properties);
      })
      .catch((error) => {
        toast.error(error.message);
      });
  }, []);

  // main part which fetches the data
  useEffect(() => {
    if (location.hash === "#map_opened") {
      return;
    }

    setTimeout(() => {
      const listingCards = document.getElementById("properties-list");
      if (window.innerWidth < 992 && listingCards && params.pagination.page !== 1) {
        listingCards.scrollIntoView({ behavior: "smooth" });
      }
      fetchProperties();
    }, 0);

    return () => {
      setAvailableProperties([]);
      // setSearchCriteria(initialSearchState);
      // setExtraDetails(initialExtraDetailsState);
      setIsLoading(true);
    };
  }, [location.search, location.hash]);

  // fetch liked properties , if the user is logged in
  useEffect(() => {
    if (!isLogged) return;
    if (availableProperties?.length < 1) return;
  }, [availableProperties]);

  const handlePageChange = (_, number) => {
    goToPropertyListingPage(params.pagination.limit, number, params.searchOptions.roomCountType, params.filters, params.sortOptions.type);
  };

  const handleSort = (value) => {
    // first replace page with 1 in search
    const search = location.search.replace(/&page=\d+/, `&page=1`);

    if (search.includes("sortType")) {
      let _search = "";

      if (value === "default") {
        _search = search.replace(/&sortType=\w+/, ``);
        navigate(`/properties${_search}${window.location.hash}`);
      } else {
        _search = search.replace(/sortType=\w+/, `sortType=${value}`);
        navigate(`/properties${_search}${window.location.hash}`);
      }
    } else {
      const _splitedSearch = search.split("&limit");
      const firstPart = _splitedSearch[0];
      const secondPart = `&limit${_splitedSearch[1]}`;

      navigate(`/properties${firstPart}&sortType=${value}${secondPart}${window.location.hash}`);
    }
  };

  const goToPropertyListingPage = (limit, page = 1, searchRoomCountType, filters = null, sortType = null) => {
    setIsTouched(true);

    if (!searchRoomCountType) {
      searchRoomCountType = "suggestion";
    }

    const newErrors = { ...errors };

    const { location, guests, bookingDates } = searchCriteria;

    const noLocation = _.isEmpty(location?.country);

    if (noLocation) {
      newErrors.location = "Please select a location";
    }

    if (guests.childCount > 0) {
      if (guests.childAges.length === 0) {
        newErrors.guests = "Please select the child age";
      }

      const isValidAge = guests.childAges.every((age) => age >= 0 && age < 18);

      if (!isValidAge) {
        newErrors.guests = "Please select the child age";
      }
    }

    let noOfNights = moment(bookingDates.checkoutDate).diff(moment(bookingDates.checkinDate), "days");

    if (noOfNights > 90) {
      newErrors.bookingDates = "Select a date range up to 90 days";
    }

    let checkin = moment(bookingDates.checkinDate);
    let checkout = moment(bookingDates.checkoutDate);

    // if (!checkin.isValid()) {
    //   newErrors.bookingDates = "Please select dates";
    // }

    if (Object.values(newErrors).some((error) => error)) {
      setErrors(newErrors);
      return;
    }

    if (!checkout.isValid() || checkout.isBefore(checkin) || checkin.isSame(checkout, "day")) {
      checkout = checkin.clone().add(1, "day");

      setSearchCriteria((prev) => ({
        ...prev,
        bookingDates: {
          checkinDate: checkin.format("YYYY-MM-DD"),
          checkoutDate: checkout.format("YYYY-MM-DD"),
        },
      }));
    }

    limit = limit || params.pagination.limit;

    // This is important - Use the latest booking dates within the same render cycle.
    const finalBookingDates = {
      checkinDate: checkin.format("YYYY-MM-DD"),
      checkoutDate: checkout.format("YYYY-MM-DD"),
    };

    const url = generateListingUrl({
      params,
      searchCriteria: {
        ...searchCriteria,
        bookingDates: finalBookingDates,
      },
      searchOptions: {
        roomCountType: searchRoomCountType,
      },
      pagination: {
        limit,
        page,
      },
      filters: filters ?? {},
      sortType: sortType,
    });

    navigate(url);
  };

  const isLessRoomSuggestionExists = summary?.isLessRoomSuggestionExists;
  const isGreaterRoomSuggestionExists = summary?.isGreaterRoomSuggestionExists;

  let suggestionWording = generateSuggestionTypeWording(
    isLessRoomSuggestionExists,
    isGreaterRoomSuggestionExists,
    params.guests.roomCount,
    params.searchOptions.roomCountType
  );

  return (
    <>
      <Helmet>
        <title>Discover Our Properties</title>
        <meta
          name="description"
          content="Explore a variety of comfortable and welcoming properties on HotelsHippo. Find your ideal stay for a memorable experience."
        />
      </Helmet>
      <div>
        <div className=" container propert-listing-cards">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              goToPropertyListingPage();
            }}
          >
            <div className="prop-listing-search">
              <div>
                <LocationSearch searchCriteria={searchCriteria} setSearchCriteria={setSearchCriteria} setErrors={setErrors} />
                {isTouched && errors.location && <div className="error-msg-home">{errors.location || "Please select a location"}</div>}
              </div>

              <div className="top-filter">
                <CheckInCheckOutCalender searchCriteria={searchCriteria} setSearchCriteria={setSearchCriteria} setErrors={setErrors} />
                {/* {isTouched && errors.bookingDates && <div className="error-msg">{errors.bookingDates || "Please select dates"}</div>} */}
              </div>

              <div className="top-filter">
                <GuestInput searchCriteria={searchCriteria} setSearchCriteria={setSearchCriteria} setErrors={setErrors} />
                {isTouched && errors.guests && <div className="error-msg">{errors.guests || "Please select the child age"}</div>}
              </div>
              <Button className="listing-search-btn" type="submit">
                {isSearchChanged ? "Apply Changes" : "Search"}
              </Button>
            </div>
          </form>

          <div id="properties-list" className="p-listing-sort-wrapper">
            <div className="p-listing-heading">
              <h4>{formatLocation(params.location)}</h4>

              <p className="text-center text-sm-start">
                {isLoading ? (
                  <Skeleton count={1} height={24} width={150} className="m-auto m-sm-0" />
                ) : (
                  `${summary.totalProperties || "No"} ${summary.totalProperties > 1 ? "properties" : "property"} found`
                )}
              </p>
            </div>
            <div className="p-lising-des-sort">
              {/*Sorting Tab */}
              <div className="p-lising-sort-title">Sort by :</div>
              <PropertiesSort handleSort={handleSort} selectedSort={params.sortOptions.type} />
            </div>
          </div>

          <div className="property-listing-wrapper">
            {/* Filter Side Menu  */}
            <div className="p-listing-left d-none d-lg-block">
              {window.innerWidth >= 992 && (
                <GoogleMap
                  params={params}
                  filters={filterItems}
                  paramFilters={paramFilters}
                  searchCriteria={searchCriteria}
                  setSearchCriteria={setSearchCriteria}
                  setErrors={setErrors}
                  handleSort={handleSort}
                />
              )}

              <FiltersDesktop params={params} filters={filterItems} paramFilters={paramFilters} summary={summary} />
            </div>

            {/* Property Listing and Sorting Tab */}
            <div className="p-listing-right">
              {/* Sorting and filter for small devices */}
              <div className="p-list-lg-filters d-lg-none filters">
                <PropertyFilterModal params={params} filters={filterItems} paramFilters={paramFilters} summary={summary} />

                <ListingSortModal handleSort={handleSort} selectedSort={params.sortOptions.type} />
                {window.innerWidth < 992 && (
                  <GoogleMap
                    params={params}
                    filters={filterItems}
                    paramFilters={paramFilters}
                    searchCriteria={searchCriteria}
                    setSearchCriteria={setSearchCriteria}
                    setErrors={setErrors}
                    handleSort={handleSort}
                  />
                )}
              </div>

              <div>
                {!!suggestionWording &&
                  (isGreaterRoomSuggestionExists || isLessRoomSuggestionExists || params.searchOptions.roomCountType !== "suggestion") && (
                    <p className="listing-suggestion-type-wrapper box-border">
                      {suggestionWording}
                      <SelectSuggestionType goToPropertyListingPage={goToPropertyListingPage} />
                    </p>
                  )}

                {suggestedProperties?.length > 0 &&
                  suggestedProperties.map((property) => {
                    if (property?.finalPrice === 0 || !property?.availableRooms?.length)
                      return <SuggestedPropertyCard property={property} key={property.id} />;
                  })}

                {!isLoading && availableProperties?.length === 0 && suggestedProperties?.length === 0 && (
                  <div className="afterload">
                    <GlobalImage src={notAvailableImg} alt="No properties found" />
                  </div>
                )}

                {availableProperties?.length === 0 && isLoading && <SkeletonCardsWrapper />}

                {availableProperties?.length > 0 &&
                  availableProperties?.map((property, idx) => {
                    if (property?.finalPrice === 0 || !property?.availableRooms?.length)
                      return <NotAvailablePropertyCard key={property.id} property={property} />;
                    return <PropertyCard idx={idx} key={property.id} property={property} params={params} />;
                  })}

                {pagination?.totalPages > 0 && (
                  <Pagination
                    className="right_pagination"
                    page={pagination.currentPage}
                    count={pagination.totalPages}
                    onChange={handlePageChange}
                    variant="outlined"
                    shape="rounded"
                    size="large"
                    siblingCount={window.innerWidth > 768 ? 1 : 0}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default PropertyListing;

function generateSuggestionTypeWording(is_less_room_sugg_exists, is_greater_room_sugg_exists, rooms, suggestion_type) {
  const room_wording = rooms === 1 ? "room" : "rooms";

  if (suggestion_type === "suggestion") {
    let roomMessage = null;

    if (is_less_room_sugg_exists && is_greater_room_sugg_exists) {
      roomMessage = `less than ${rooms} ${room_wording} and some have more than ${rooms}`;
    } else if (is_less_room_sugg_exists) {
      roomMessage = `less than ${rooms} ${room_wording}`;
    } else if (is_greater_room_sugg_exists) {
      roomMessage = `more than ${rooms} ${room_wording}`;
    }

    if (!roomMessage) return null;

    return "Some options have " + roomMessage + ". Show results with ";
  }

  let suggestion_type_wording = null;

  if (suggestion_type === "eq") {
    suggestion_type_wording = `Showing options with ${rooms} ${room_wording} only`;
  } else if (suggestion_type === "gte") {
    suggestion_type_wording = `Showing options with ${rooms} ${room_wording} or more`;
  } else if (suggestion_type === "lte") {
    suggestion_type_wording = `Showing options with ${rooms} ${room_wording} or less`;
  }

  if (!suggestion_type_wording) return null;

  return suggestion_type_wording + ". Include results with";
}

function isSearchValuesChanged(params = {}, searchCriteria = {}) {
  // Extract keys from searchCriteria for comparison
  const criteriaKeys = Object.keys(searchCriteria);

  // Create a filtered version of params that includes only keys present in searchCriteria
  const filteredParams = _.pick(params, criteriaKeys);

  // Now compare searchCriteria with filteredParams
  return !_.isEqual(searchCriteria, filteredParams);
}
function formatLocation(location) {
  let formattedLocation = "";

  if (location.city) {
    formattedLocation += `${location.city}, `;
  } else if (location.district) {
    formattedLocation += `${location.district} District, `;
  } else if (location.province) {
    formattedLocation += `${location.province} Province, `;
  }

  if (location.country) {
    formattedLocation += location.country;
  }

  return formattedLocation.trimEnd();
}

export { isSearchValuesChanged };
